/* Code generated with AutoHTML Plugin for Figma */
import { Article } from "@project/shared-types";
import { _sizeHeading, _sizeText, _style } from "../../core/core";
import { get_date_from_string } from "../../hooks/date_tool";
import { Link } from "../link/link";
import { Text } from "../texts/text";
import Title from "../texts/title";
import "./Article.css";
interface ArticleProps {
  articleData: Article;
}
export const ArticleView = ({ articleData, ...props }: ArticleProps) => {
  return (
    <a key={articleData.id} href={articleData.url} className="blog-article">
      <div className="blog-content">
        <div className="blog-content-body">
          <Title type={_sizeHeading.h3}>{articleData.title}</Title>

          <div className="blog-content-text">
            <Text size={_sizeText.hmp2}>{articleData.description}</Text>
            <Link style={_style.linkDefault} link={articleData.url}>
              Читать дальше
            </Link>
          </div>
        </div>

        <div className="blog-content-footer">
          <Text size={_sizeText.hmp2}>
            {get_date_from_string(articleData.date_modified)}
          </Text>
        </div>
      </div>
    </a>
  );
};
